<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Promotion Information</div>
      </div>
      <v-spacer></v-spacer>
      <div slot="action" v-if="!newPromotion">
        <v-tooltip top>
          <v-btn slot="activator" icon @click="doQuery">
            <v-icon color="primary">mdi-magnify</v-icon>
          </v-btn>
          <span>Query Promotion</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6 v-if="newPromotion">
            <v-text-field :label="labels.promotion" v-model="promotionForm.promotion" :error-messages="errors.collect('promotion')" v-validate="'required|param|max:12'" data-vv-name="promotion" :data-vv-as="labels.promotion"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.promotionQuery}}</v-subheader>
            <div class="title">{{promotionForm.promotion}}</div>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.description" v-model="promotionForm.description" :error-messages="errors.collect('description')" v-validate="'required|entry|max:128'" data-vv-name="description" :data-vv-as="labels.description"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs7>
                <cal-picker v-model="effDate" :label="labels.effDate" v-validate="'required'" :data-vv-as="labels.effDate" data-vv-name="effDate" :error-messages="errors.collect('effDate')" @input="doEffDate"></cal-picker>
              </v-flex>
              <v-flex xs5>
                <time-picker v-model="effTime" :label="labels.effTime" v-validate="'required'" :data-vv-as="labels.effTime" data-vv-name="effTime" :error-messages="errors.collect('effTime')" @input="doEffDate"></time-picker>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs7>
                <cal-picker v-model="endDate" :label="labels.endDate" v-validate="endDateValidation" :min="this.effDate" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" @input="doEndDate"></cal-picker>
              </v-flex>
              <v-flex xs5>
                <time-picker v-model="endTime" :label="labels.endTime" v-validate="'required'" :data-vv-as="labels.endTime" data-vv-name="endTime" :error-messages="errors.collect('endTime')" @input="doEndDate"></time-picker>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox :label="labels.enabledB2C" v-model="promotionForm.enabledB2C" data-vv-name="enabledB2C" :data-vv-as="labels.enabledB2C"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox :label="labels.enabledB2B" v-model="promotionForm.enabledB2B" data-vv-name="enabledB2B" :data-vv-as="labels.enabledB2B"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs3>
                <v-checkbox :label="labels.stdPromo" v-model="promotionForm.stdPromo" data-vv-name="stdPromo" :data-vv-as="labels.stdPromo"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox :label="labels.usrGrpPromo" v-model="promotionForm.usrGrpPromo" data-vv-name="usrGrpPromo" :data-vv-as="labels.usrGrpPromo"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox :label="labels.cardPromo" v-model="promotionForm.cardPromo" data-vv-name="cardPromo" :data-vv-as="labels.cardPromo"></v-checkbox>
              </v-flex>
              <v-flex xs3>
                <v-checkbox :label="labels.couponPromo" v-model="promotionForm.couponPromo" data-vv-name="couponPromo" :data-vv-as="labels.couponPromo"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              {{newPromotion? 'Add Promotion' : 'Update Promotion'}}
              <v-icon right>{{newPromotion? 'mdi-star' : 'mdi-content-save'}}</v-icon>
              </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import toDate from 'date-fns/toDate'
import { formatDisplayTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { PROMOTION_SIDEMENU } from '@/store/types'

export default {
  data() {
    return {
      labels: {
        promotion: 'Promotion Code*',
        promotionQuery: 'Promotion Code',
        description: 'Promotion Description*',
        effDate: 'Effective Date*',
        effTime: 'Time*',
        endDate: 'End Date*',
        endTime: 'Time*',
        enabledB2C: 'Enabled for B2C',
        enabledB2B: 'Enabled for B2B',
        stdPromo: 'Standard Promotion',
        usrGrpPromo: 'User Group Promotion',
        cardPromo: 'Credit Card Promotion',
        couponPromo: 'Coupon Promotion'
      },
      promotionForm: {
        promotion: undefined,
        description: undefined,
        effDate: undefined,
        endDate: undefined,
        enabledB2C: false,
        enabledB2B: false,
        stdPromo: false,
        usrGrpPromo: false,
        cardPromo: false,
        couponPromo: false,
        revision: undefined
      },
      menu: [],
      newPromotion: false,
      submitting: false,
      effDate: undefined,
      effTime: undefined,
      endDate: undefined,
      endTime: undefined
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    endDateValidation() {
      return 'required|start_enddate:' + this.promotionForm.effDate
    }
  },
  methods: {
    async doInit() {
      if (!this.newPromotion) {
        // Review
        await this.reviewPromotion(this.promotion)
      }
    },
    async reviewPromotion(xPromotion) {
      const apiURI = this.$store.state.promotionManagement.menu.promotionGet
      if (apiURI) {
        try {
          const expand = {
            promotion: xPromotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion init
            this.promotionForm.promotion = data.promotion.promotion
            this.promotionForm.description = data.promotion.description
            this.promotionForm.effDate = data.promotion.effDate
            this.promotionForm.endDate = data.promotion.endDate
            this.promotionForm.enabledB2C = data.promotion.enabledB2C
            this.promotionForm.enabledB2B = data.promotion.enabledB2B
            this.promotionForm.stdPromo = data.promotion.stdPromo
            this.promotionForm.usrGrpPromo = data.promotion.usrGrpPromo
            this.promotionForm.cardPromo = data.promotion.cardPromo
            this.promotionForm.couponPromo = data.promotion.couponPromo
            this.promotionForm.revision = data.promotion.revision
            if (this.promotionForm.effDate) {
              this.effDate = this.promotionForm.effDate
              this.effTime = formatDisplayTime(this.promotionForm.effDate)
            }
            if (this.promotionForm.endDate) {
              this.endDate = this.promotionForm.endDate
              this.endTime = formatDisplayTime(this.promotionForm.endDate)
            }

            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doEffDate() {
      // Format Effective Date
      if (this.effDate && this.effTime && this.effTime.length === 5) {
        const hr = this.effTime.substring(0, 2)
        const min = this.effTime.substring(3, 5)
        this.effDate = toDate(this.effDate)
        this.effDate.setHours(hr)
        this.effDate.setMinutes(min)
        this.promotionForm.effDate = this.effDate
      }
    },
    doEndDate() {
      // Format Expiry Date
      if (this.endDate && this.endTime && this.endTime.length === 5) {
        const hr = this.endTime.substring(0, 2)
        const min = this.endTime.substring(3, 5)
        this.endDate = toDate(this.endDate)
        this.endDate.setHours(hr)
        this.endDate.setMinutes(min)
        this.promotionForm.endDate = this.endDate
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPromotion) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.promotionForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.reviewPromotion(this.promotionForm.promotion)
            let newSideMenu = []
            newSideMenu.push({ name: 'promotionReview', text: 'Promotion', icon: 'mdi-star' })
            newSideMenu.push({ name: 'promotionFactorReview', text: 'Factor/Rates', icon: 'mdi-sale' })
            if (this.promotionForm.cardPromo) {
              newSideMenu.push({ name: 'promotionCreditCardReview', text: 'Credit Card List', icon: 'mdi-credit-card-multiple' })
            }
            if (this.promotionForm.couponPromo) {
              newSideMenu.push({ name: 'promotionCouponReview', text: 'Coupons', icon: 'mdi-ticket-percent' })
            }
            if (this.promotionForm.usrGrpPromo) {
              newSideMenu.push({ name: 'promotionMemberGroupReview', text: 'Member Groups', icon: 'mdi-wallet-membership' })
            }
            this.$store.commit(PROMOTION_SIDEMENU, newSideMenu)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.menu.promotionCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promotionForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newPromotion = false
            this.$router.push({ name: 'promotionReview', params: { promotion: this.promotionForm.promotion } })
            await this.reviewPromotion(this.promotionForm.promotion)

            let newSideMenu = []
            newSideMenu.push({ name: 'promotionReview', text: 'Promotion', icon: 'mdi-star' })
            newSideMenu.push({ name: 'promotionFactorReview', text: 'Factor/Rates', icon: 'mdi-sale' })
            if (this.promotionForm.cardPromo) {
              newSideMenu.push({ name: 'promotionCreditCardReview', text: 'Credit Card List', icon: 'mdi-credit-card-multiple' })
            }
            if (this.promotionForm.couponPromo) {
              newSideMenu.push({ name: 'promotionCouponReview', text: 'Coupons', icon: 'mdi-ticket-percent' })
            }
            if (this.promotionForm.usrGrpPromo) {
              newSideMenu.push({ name: 'promotionMemberGroupReview', text: 'Member Groups', icon: 'mdi-wallet-membership' })
            }
            this.$store.commit(PROMOTION_SIDEMENU, newSideMenu)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doQuery() {
      this.$router.push({ name: 'promotionQuery', params: { promotion: this.promotion } })
    }
  },
  created() {
    if (this.promotion === 'New') {
      this.newPromotion = true
      this.effTime = '00:00'
      this.endTime = '00:00'
    } else {
      this.doInit()
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
